module.exports = __webpack_public_path__ + "static/media/gryphon-house-transform-3.87706d5c.jpeg";